import { selectDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';

const LLINKID_GUIDING_PRINCIPLE: BuildingBlockNodeConfig = {
  nodeSelector: selectDescriptionNode,
  information: {
    single: 'Krachtlijn',
    plural: 'Krachtlijn',
  },

  buildingBlocks: [],
  edit: [llinkidDescriptionComponent],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINKID_GUIDING_PRINCIPLE;
